import { Search } from "lucide-react";
import { Input } from "../ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { KAT_DOT } from "../KondisiBadge";

const KATS = ["BAIK", "RUSAK RINGAN", "RUSAK BERAT", "LAINNYA"];

export const ItemFilters = ({ cat, q, setQ, kondisi, setKondisi, base, showPolda, polda, setPolda, poldaOptions }) => {
  const count = (k) => base.filter((i) => i.kondisi_kat === k).length;
  return (
    <div className="border bg-card">
      <div className="flex flex-col md:flex-row gap-3 p-3">
        <div className="relative flex-1">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cari nama, nomor seri, pemegang..."
            className="pl-9 h-10" data-testid="search-input" />
        </div>
        {showPolda && (
          <Select value={polda} onValueChange={setPolda}>
            <SelectTrigger className="md:w-64" data-testid="polda-filter"><SelectValue placeholder="Semua Polda" /></SelectTrigger>
            <SelectContent className="max-h-72">
              <SelectItem value="ALL">Semua Polda</SelectItem>
              {poldaOptions.map((p) => <SelectItem key={p} value={p}>{p}</SelectItem>)}
            </SelectContent>
          </Select>
        )}
      </div>
      {cat.has_kondisi && (
        <div className="flex flex-nowrap overflow-x-auto border-t [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          <button onClick={() => setKondisi("ALL")} data-testid="kondisi-filter-ALL"
            className={`shrink-0 whitespace-nowrap px-4 py-2.5 text-xs font-semibold uppercase tracking-wide border-r transition-colors ${kondisi === "ALL" ? "bg-primary text-primary-foreground" : "hover:bg-muted"}`}>
            Semua · {base.length}
          </button>
          {KATS.map((k) => (
            <button key={k} onClick={() => setKondisi(k)} data-testid={`kondisi-filter-${k.replace(" ", "-")}`}
              className={`shrink-0 whitespace-nowrap px-4 py-2.5 text-xs font-semibold uppercase tracking-wide border-r flex items-center gap-2 transition-colors ${kondisi === k ? "bg-primary text-primary-foreground" : "hover:bg-muted"}`}>
              <i className={`h-2 w-2 ${KAT_DOT[k]}`} />{k} · {count(k)}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
